import DOMPurify from 'dompurify';
import type { Config } from 'dompurify';

import type { Sanitizer } from './sanitize.types';

class BrowserSanitizer implements Sanitizer {
    public sanitize(html: string, config: Config): string {
        return DOMPurify.sanitize(html, config);
    }
}

export const browserSanitizer: Sanitizer = new BrowserSanitizer();
